import { useTheme } from '@emotion/react'
import React from 'react'
import { themedValue } from '../../__styling'
import { StyledHeading, StyledWebLink } from '../EmailPreference.styled'
import { StyledFooter } from './Unsubscribe.styled'

export const UnsubscribeFooter = () => {
    const theme = useTheme()
    const contactLink = themedValue(theme, {
        thewest: '/contact',
        perthnow: '/contact-us',
        sevennews: '/contact-us',
        fallback: '/contact',
    })
    return (
        <StyledFooter>
            <StyledHeading>Looking for something else?</StyledHeading>
            <StyledWebLink to={contactLink}>Contact us</StyledWebLink>
        </StyledFooter>
    )
}
